<template>
  <div class="ExpertDashboard">
    <MobileNav :page_title="nav_title"></MobileNav>

    <div class="sideBarSection">
      <UserDashboardSideBar :active_sub_menu="active_subMenu_link" :filterList="filter_list" :resetFilters="reset_filter" v-if="isDesktop"></UserDashboardSideBar>
    </div>

    <div class="reco-details-container">
      <div class="sub-menu-section">
        <div class="sub-menu-bar-wrapper">
          <div class="sub-menu-bar">
            <div
              class="sub-menu-bar-link cursor-pointer"
              @click="setActiveSubMenuLink('TOP_STOCKS')"
              :class="{'active-sub-menu-link' : active_subMenu_link == 'TOP_STOCKS'}"
            >Top Stocks</div>
            <div
              class="sub-menu-bar-link cursor-pointer"
              @click="setActiveSubMenuLink('TOP_SECTORS')"
              :class="{'active-sub-menu-link' : active_subMenu_link == 'TOP_SECTORS'}"
            >Top Sectors</div>
          </div>
        </div>

        <div class="action-btn-wrapper">
          <span class="past-reco-btn" style="font-size: 0.7rem;" @click="goToPastReco()">Check opinions</span>
          <span class="back-btn" style="font-size: 0.7rem; margin: 0 15px;" @click="goBack()">Back</span>
        </div>
      </div>

      <div class="reco-details-section">

        <div v-if="active_subMenu_link == 'TOP_STOCKS'">
          <!-- passed expert's id to get his top stock details -->
          <ExpertDashboardTopStocks @filters="getFilterList" @resetAllSelectedFilters="resetAllSelectedFilters" :user_id="$route.query.user_id"></ExpertDashboardTopStocks>
        </div>

        <div v-if="active_subMenu_link == 'TOP_SECTORS'">
          <!-- passed expert's id to get his top sector details -->
          <ExpertDashboardTopSectors @filters="getFilterList" @resetAllSelectedFilters="resetAllSelectedFilters" :user_id="$route.query.user_id"></ExpertDashboardTopSectors>
        </div>

        <MobileDashboardFilterDialog v-if="!isDesktop" :active_sub_menu="active_subMenu_link" :filterList="filter_list" :resetFilters="reset_filter" class="nav-filter-icon"></MobileDashboardFilterDialog>
      </div>
    </div>


  </div>
</template>

<script>
import { serverAddr } from "../networkConfig";
import { screenSize } from "../mixins/ScreenSize.js";
import UserDashboardSideBar from "@/components/UserDashboardSideBar";
import ExpertDashboardTopStocks from "@/components/ExpertDashboardTopStocks.vue";
import ExpertDashboardTopSectors from "@/components/ExpertDashboardTopSectors.vue";
import MobileNav from "@/components/MobileNav.vue";
import MobileDashboardFilterDialog from "@/components/MobileDashboardFilterDialog.vue";

export default {
  name: "ExpertDashboard",
  components: {
    UserDashboardSideBar,
    ExpertDashboardTopStocks,
    ExpertDashboardTopSectors,
    MobileNav,
    MobileDashboardFilterDialog
  },

  mixins: [screenSize],

  data() {
    return {
      nav_title: "Home",
      active_subMenu_link: "TOP_STOCKS",
      filter_list: '',
      reset_filter: false,
    };
  },

  beforeRouteEnter (to, from, next) {
    // if user has access code then check user id in url params and access code of expert both are not same
    // then restrict user to access this page and redirect user to home page

    // else if user doesn't have access code and not subscribed to any pricing plan
    // then redirect user to dashboard other wise let him access the page

    let subscribed_plan = JSON.parse(localStorage.getItem("plan_details"));
    let user_id = from.query.user_id ? from.query.user_id : to.query.user_id ? to.query.user_id : null;
    let is_public = from.query.public ? from.query.public : to.query.public ? to.query.public : '';

    //checked is user id and is public is in route then continue otherwise redirected to dashboard
    if(user_id){

      if(((!Object.keys(subscribed_plan).length) || subscribed_plan.plan == 'Lite') && localStorage.getItem("access_to_expert_dashboard")){

        if(localStorage.getItem("access_to_expert_dashboard") != user_id){
          next({ name: 'dashboard' });
        }

      }else if((!Object.keys(subscribed_plan).length) || subscribed_plan.plan == 'Lite'){  //if not subscribed to paid plan

        next({ name: 'dashboard' });

      }
      // else if(subscribed_plan.plan == 'Lite'){    //if subscribed to lite plan

      //   next({ name: 'dashboard' });

      // }
    }else{

      next({ name: 'dashboard' });
    }
    next();
  },

  mounted(){
    if(!Object.keys(this.expertProfile).length || !this.expertProfile.name){
      this.getExpretsDetails();
    }
  },

  methods: {
    //get experts details
    getExpretsDetails() {
      serverAddr
      .post("/performers/v1/expert/profile", {
        user_id: Number(this.$route.query.user_id)
      })
      .then(response => {
        if (response.data.status) {
          if(response.data.data.length){
            this.$store.commit('commitExpertDetails', response.data.data[0]);
          }else{
            this.$store.commit('commitExpertDetails', {});
          }
        }else{
          this.$store.commit('commitExpertDetails', {});
        }
      })
      .catch((error) => {
        console.log(error);
      });
    },

    getFilterList(list){
      this.filter_list = list;
    },

    //to reset all selected filters after changing sub menu or changing tables headers
    resetAllSelectedFilters(){
      this.reset_filter = !this.reset_filter;
    },

    //set active sub menu links e.g. last reco, accuracy achieved
    setActiveSubMenuLink(label) {
      if(label == 'TOP_STOCKS'){
        this.active_subMenu_link = label;
      }else if(label == 'TOP_SECTORS'){
        this.active_subMenu_link = label;
      }

      this.active_period = "1M";

      this.resetAllSelectedFilters();

      // on menu select scroll page to top
      var elmnt = document.getElementsByClassName("ExpertDashboard")[0];
      scrollTo(elmnt, 0, 100);
    },

    goToPastReco(){
      if( (!Object.keys(this.subscribedPlanDetails).length || this.subscribedPlanDetails.plan == "Lite") && localStorage.getItem("access_to_expert_dashboard") && this.$route.query.user_id){

        if(localStorage.getItem("access_to_expert_dashboard") == this.$route.query.user_id){

          this.$router.push({ name: "expertsPastRecommendations", query: { user_id: this.$route.query.user_id, user: this.$route.query.user, public: this.$route.query.is_public ? this.$route.query.is_public : false }});

        }else{

          this.$store.commit('commitSubscribPlanDialogVisibility', true);

        }

      }else if(!Object.keys(this.subscribedPlanDetails).length){
        // checked that user has subscribed to any plan

        this.$store.commit('commitSubscribPlanDialogVisibility', true);

      }else if(Object.keys(this.subscribedPlanDetails).length && (this.subscribedPlanDetails.plan == "Premium" || this.subscribedPlanDetails.plan == "Pro")){

        this.$router.push({ name: "expertsPastRecommendations", query: { user_id: this.$route.query.user_id, user: this.$route.query.user, public: this.$route.query.is_public ? this.$route.query.is_public : false }});
      }
    },

    goBack(){
      this.$router.go(-1) ;
    }
  },

  computed: {
    //returns subscribed plan details from local storage
    subscribedPlanDetails(){
      return JSON.parse(localStorage.getItem("plan_details"));
    },

    //returns stored user profile from local storage
    expertProfile() {
      return this.$store.state.expert_details;
    },
  }
};
</script>

<style lang="scss">
@import "../css/variable.scss";
@import "../css/common.scss";

.ExpertDashboard {
  min-height: 100vh;
  background-color: $page-background-color;
  padding: 60px 0 0 0;
}
.ExpertDashboard .reco-details-container {
  width: calc(100% - 265px);
  margin-left: 265px;
  min-height: 100vh;
}
.ExpertDashboard .reco-details-section {
  padding: 65px 10px 0 10px;
}
.ExpertDashboard .sub-menu-bar-wrapper {
  width: 50%;
  display: inline-block;
}
.ExpertDashboard .action-btn-wrapper{
  width: 50%;
  text-align: right;
  display: inline-block;

  .past-reco-btn{
    border: 1px solid $primary-theme-color;
    color: $primary-theme-color;
    font-size: 9px;
    font-weight: 600;
    padding: 3px 5px;
    border-radius: 10px;
    cursor: pointer;
    transition: 0.2s;
    white-space: nowrap;
  }
  .past-reco-btn:hover{
    background-color: $primary-theme-color;
    color: #fff;
  }
  .back-btn{
    // color: #2488fe;
    color: $secondary-theme-color;
    font-size: 9px;
    font-weight: 600;
    cursor: pointer;
  }
}
.ExpertDashboard .sub-menu-section {
  background: $page-background-color;
  width: calc(100% - 260px);
}
.ExpertDashboard .footer-section {
  width: calc(100% - 260px);
  margin-left: 260px;
}
.no-data-labels{
  position: absolute;
  top: 20px;
  left: 0;
  right: 0;
}
.axis-description{
  color: #333;
  font-size: 10px;
  font-weight: 600;
  text-align: center;
}
@media screen and (max-width: 1283px) {
  .ExpertDashboard {
    padding: 50px 0 0 0;
  }
  .ExpertDashboard .sub-menu-section, .sub-menu-bar {
    width: 100%;
  }
  .ExpertDashboard .reco-details-container,
  .ExpertDashboard .footer-section {
    width: 100%;
    margin-left: 0;
  }
  .ExpertDashboard .reco-details-section {
    padding: 60px 10px 0 10px;
  }
  .ExpertDashboard .sideBarSection {
    display: none;
  }
}
@media screen and (max-width: 575px){
  .ExpertDashboard .reco-details-section {
    padding: 85px 10px 0 10px;
  }
  .ExpertDashboard .sub-menu-bar-wrapper {
    width: 100%;
  }
  .ExpertDashboard .action-btn-wrapper{
    width: 100%;
    text-align: center;
  }
  .ExpertDashboard .action-btn-wrapper{
    padding: 0 0 10px 0;
  }
}
</style>
